import { databases } from '../lib/appwrite';
import { Query } from 'appwrite';

// ============================================
// PICKUP POINT SERVICE
// ============================================

const DATABASE_ID = process.env.REACT_APP_APPWRITE_DATABASE_ID;
const PICKUPPOINT_COLLECTION_ID = process.env.REACT_APP_APPWRITE_PICKUPPOINT_COLLECTION_ID;
const CONDOMINIUM_COLLECTION_ID = process.env.REACT_APP_APPWRITE_CONDOMINIUM_COLLECTION_ID;

/**
 * Get all pickup points from the database
 * @returns {Promise<Array>} - Array of pickup point objects
 */
export const getAllPickupPoints = async () => {
  try {
    const response = await databases.listDocuments(
      DATABASE_ID,
      PICKUPPOINT_COLLECTION_ID
    );
    
    return response.documents.map(doc => ({
      id: doc.$id,
      name: doc.name,
      condoId: doc.condo_id
    }));
  } catch (error) {
    console.error('Error fetching pickup points:', error);
    throw error;
  }
};

/**
 * Get pickup points for a specific condominium
 * @param {string} condoId - The condominium ID
 * @returns {Promise<Array>} - Array of pickup point objects
 */
export const getPickupPointsByCondoId = async (condoId) => {
  try {
    const response = await databases.listDocuments(
      DATABASE_ID,
      PICKUPPOINT_COLLECTION_ID,
      [Query.equal('condo_id', condoId)]
    );
    
    return response.documents.map(doc => ({
      id: doc.$id,
      name: doc.name,
      condoId: doc.condo_id
    }));
  } catch (error) {
    console.error('Error fetching pickup points for condominium:', error);
    throw error;
  }
};

/**
 * Get a single pickup point by ID
 * @param {string} pickupPointId - The pickup point ID
 * @returns {Promise<Object>} - Pickup point object with residence name
 */
export const getPickupPointById = async (pickupPointId) => {
  try {
    const pickupPoint = await databases.getDocument(
      DATABASE_ID,
      PICKUPPOINT_COLLECTION_ID,
      pickupPointId
    );
    
    // Fetch residence name
    let residenceName = '';
    if (pickupPoint.condo_id) {
      try {
        const residence = await databases.getDocument(
          DATABASE_ID,
          CONDOMINIUM_COLLECTION_ID,
          pickupPoint.condo_id
        );
        residenceName = residence.name;
      } catch (residenceError) {
        console.error('Error fetching residence:', residenceError);
      }
    }
    
    return {
      id: pickupPoint.$id,
      name: pickupPoint.name,
      condoId: pickupPoint.condo_id,
      residenceName: residenceName,
      fullName: residenceName ? `${residenceName} (${pickupPoint.name})` : pickupPoint.name
    };
  } catch (error) {
    console.error('Error fetching pickup point:', error);
    throw error;
  }
};

// ============================================
// DATABASE SCHEMA REFERENCE
// ============================================
// 
// PickupPoints Collection Schema:
// Collection ID: pickuppoints
// 
// Attributes:
// - name (String): Name of the pickup point (e.g., "Building A, Lobby")
// - condo_id (String): Foreign key to the Condominiums collection
// 
